import React from "react";
import "./styles.css";
import { useTranslation } from "react-i18next";

const DevOpsRoadMap = () => {

  const { t } = useTranslation("devOpsPage");
  const roadMapData = t("devOpsPageRoadMap", { returnObjects: true })

  return (
    <>
      <div className="devops-road-map-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="devops-engagment-model-text">
                {roadMapData?.mainHeading} <span style={{ color: '#80b927' }}>{roadMapData?.greenHeading}</span>
              </h1>
              <h3 className="devops-sub-heading">{roadMapData?.sectionDescription}</h3>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="devops-prover-box-map-left ">
                <div className="devops-proven-roadmap-text devops-road-map-left-space second">
                  <h2>{roadMapData?.roadMapHeading1}</h2>
                  <p className="devops-common-text">{roadMapData?.roadMapDescription1}</p>
                </div>

                <div className="devops-proven-roadmap-text forth">
                  <h2>{roadMapData?.roadMapHeading2}</h2>
                  <p className="devops-common-text">{roadMapData?.roadMapDescription2}</p>
                </div>
              </div>
            </div>

            <div className="col-md-4 none-tab-box position-relative">
              <div className="devops-road-image-box devops-ai-development-road-map">
                <img
                  className="devops-none-tab"
                  src="/images/devops-roadmap.svg"
                  alt="Road Map"
                />
                <img
                  className="devops-none-web-box"
                  src="/images/roadmap-tablet/roadmap4-tab.png"
                  alt="Road Map"
                />
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="right-box-text ">
                <div className="devops-proven-roadmap-text devops-road-map-left-space first">
                  <h2>{roadMapData?.roadMapHeading3}</h2>
                  <p className="devops-common-text">{roadMapData?.roadMapDescription3}</p>
                </div>

                <div className="devops-proven-roadmap-text third">
                  <h2>{roadMapData?.roadMapHeading4}</h2>
                  <p className="devops-common-text">{roadMapData?.roadMapDescription4}</p>
                </div>

                <div className="devops-proven-roadmap-text third">
                  <h2>{roadMapData?.roadMapHeading5}</h2>
                  <p className="devops-common-text">{roadMapData?.roadMapDescription5}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DevOpsRoadMap;
